import React from 'react'
import {AlertCircle} from 'react-feather'
import Avatar from '@components/avatar'

const SuccessToast = (props) => {
  const {msg, dataTestId} = props

  return (
    <div className="toastify-header">
      <div className="title-wrapper">
        <Avatar size="sm" color="success" icon={<AlertCircle size={20} />} />
        <h6 className="toast-title fw-bold" data-testid={dataTestId}>
          {msg}
        </h6>
      </div>
    </div>
  )
}

export default SuccessToast
